export default function extractFileNameFromStreamUrl(filePath: string): string {
	console.log('input filePath ...', filePath);
	
	if (filePath) {
		const pathname = new URL(filePath).pathname;
		const index = pathname.lastIndexOf('/');
		const file = pathname.substring(index + 1);
		const fileNameWithExtenation = file.substring(file.indexOf('.') + 1);
		const fileName = fileNameWithExtenation.substring(0, file.indexOf('.')).replace('%20', ' ');
		console.log('output fileName ...', fileName);
		return fileName;
	}
	return filePath;
}
